(function (module) {
  'use strict';

  function contentSearchBlockService($http) {
    function search(query, searchCategories, facetCategories, filterOn, groupCategories, pageIndex, pageSize) {
      var data = {
        query: query,
        searchCategories: searchCategories,
        facetCategories: facetCategories,
        filterOn: filterOn,
        groupCategories: groupCategories,
        pageIndex: pageIndex,
        pageSize: pageSize
      };
      return $http.post('/api/search/find', data);
    }

    return {
      search: search
    };
  }

  contentSearchBlockService.$inject = ['$http'];
  module.factory('contentSearchBlockService', contentSearchBlockService);

})(angular.module('app'));